import axios from "axios";
const apiUrl = process.env.REACT_APP_API_BASE_URL;

export const client = axios.create({
    baseURL : apiUrl,
    headers: {
        'Content-Type': 'application/json'
    }
})
